export const uploadImageToCloudinaryStorage = async (file) => {
	if (!file) {
		alert("Select a file");
		return null;
	}

	// Detect resource type automatically
	const resourceType = file.type.startsWith("video/") ? "video" : "image";

	const formData = new FormData();
	formData.append("file", file);
	formData.append("upload_preset", "offer_junction");

	try {
		const res = await fetch(
			`https://api.cloudinary.com/v1_1/deoxqwacv/${resourceType}/upload`,
			{
				method: "POST",
				body: formData,
			},
		);

		const data = await res.json();

		console.log("Cloudinary response:", data);

		if (!res.ok) {
			throw new Error(data.error?.message || "Upload failed");
		}

		return data.secure_url;
	} catch (err) {
		console.error("Cloudinary Upload Error:", err);
		return null;
	}
};
